import {
  getAllHealthcareSubcategoryKeywords,
  getHealthcareSubcategoryPriority,
  getLocaleAwareSubcategoryKeywords,
} from './languages';
import {
  type SubcategoryConfig,
  type SubcategoryResult,
  detectSubcategory,
} from './subcategoryDetection';
import { EXPENSE_TAXONOMY } from './taxonomy';

export const HEALTHCARE_KEYWORDS = getAllHealthcareSubcategoryKeywords();

/** Derived from the canonical `EXPENSE_TAXONOMY`. See taxonomy.ts. */
export const VALID_HEALTHCARE_SUBCATEGORIES =
  EXPENSE_TAXONOMY.healthcare as readonly string[] as string[];

export const HEALTHCARE_CONFIG: SubcategoryConfig = {
  keywords: HEALTHCARE_KEYWORDS,
  validSubcategories: VALID_HEALTHCARE_SUBCATEGORIES,
  contextKeywords: {},
  minConfidenceThreshold: 0.3,
  subcategoryPriority: getHealthcareSubcategoryPriority(),
};

export function detectHealthcareSubcategory(description: string): string {
  return detectSubcategory(description, HEALTHCARE_CONFIG).subcategory;
}

export function detectHealthcareSubcategoryWithConfidence(
  description: string
): SubcategoryResult {
  return detectSubcategory(description, HEALTHCARE_CONFIG);
}

/**
 * Locale-aware healthcare subcategory detector. Combines global brand
 * keywords (CVS, Walgreens, Shoppers Drug Mart, Boots, Cruz Verde,
 * Doc Morris, Unimed, AOK, AXA Santé, yoga/pilates/crossfit, etc.)
 * with the user's primary-language common-word vocabulary. Returns
 * `default@0` when locale doesn't resolve so cloud LLM can step in.
 */
export function detectHealthcareSubcategoryWithLocale(
  description: string,
  locale: string | undefined | null
): SubcategoryResult {
  const keywords = getLocaleAwareSubcategoryKeywords(
    b => b.healthcareSubcategories,
    k => k.healthcareSubcategories,
    locale
  );
  if (!keywords) {
    return { subcategory: 'default', confidence: 0, matchedKeywords: [] };
  }
  return detectSubcategory(description, {
    ...HEALTHCARE_CONFIG,
    keywords,
  });
}
